import * as v from "valibot";
import { checkPODEntryIdentifier } from "../gpcUtil.js";
import { valibotParse } from "./valibotUtil.js";
export const Schema = {
    ToJSON: v.pipe(v.string(), v.transform((n) => checkPODEntryIdentifier(n, n))),
    FromJSON: v.pipe(v.string(), v.transform((n) => checkPODEntryIdentifier(n, n)))
};
//
// Don't customize below this point.  This boilerplate is intended to be the
// same for every type, and updated by copy/paste.
//
const _ToJsonOutputCheck = {};
const _ToJsonInputCheck = {};
const _FromJsonOutputCheck = {};
const _FromJsonInputCheck = {};
export function toJSON(gpcInput) {
    return valibotParse(Schema.ToJSON, gpcInput);
}
export function fromJSON(jsonInput) {
    return valibotParse(Schema.FromJSON, jsonInput);
}
